import axios from './axios'

export const formUsersApi = {
    // Get all form users for a specific form
    getByForm: (formId) => axios.get(`/form-users/form/${formId}`),

    // Get a single form user
    getById: (userId) => axios.get(`/form-users/${userId}`),

    // Create a new form user
    create: (data) => axios.post('/form-users', data),

    // Update a form user
    update: (userId, data) => axios.put(`/form-users/${userId}`, data),

    // Delete a form user
    delete: (userId) => axios.delete(`/form-users/${userId}`),

    // Form user login
    login: (formId, email, password) => axios.post('/form-users/login', {
        form_id: formId,
        email,
        password
    }),

    // Migrate users from one form to another
    migrateUsers: (fromFormId, toFormId) => axios.post('/form-users/migrate', {
        from_form_id: fromFormId,
        to_form_id: toFormId
    }),

    // Copy users from one form to another
    copyUsers: (fromFormId, toFormId) => axios.post('/form-users/copy', {
        from_form_id: fromFormId,
        to_form_id: toFormId
    })
}

export default formUsersApi
